import { BehaviorSubject } from 'rxjs';
import type { RecordRef } from '../components/record/record.component';

const recordSubject = new BehaviorSubject<RecordRef | null>(null);
const openedRecords = new Set<RecordRef>();

function markRecordAsOpened(reference: RecordRef) {
  openedRecords.add(reference);
}

export function unmarkRecordAsOpened(reference: RecordRef) {
  openedRecords.delete(reference);
}

export function getRecordReference() {
  return recordSubject.asObservable();
}

export function setRecordReference(reference: RecordRef) {
  markRecordAsOpened(reference);
  recordSubject.next(reference);
}

export function refreshParentRecord(childRecordId: string) {
  const openedRecordsArray = Array.from(openedRecords);
  const childRecordRef = openedRecordsArray.find((recordRef) => String(recordRef.recordId) === childRecordId);

  if (childRecordRef && childRecordRef.openerRecordId) {
    const parentRecordRef = openedRecordsArray.find(
      (recordRef) => String(recordRef.recordId) === String(childRecordRef.openerRecordId)
    );

    parentRecordRef?.refreshRecord();
  }
}
